module.exports = __webpack_public_path__ + "static/qr_Channel.b3c9ca1d.png";